import React from 'react'

import { boxShadowFloat } from '@/_vars'
import { useOnClickOutsideOnDesktop } from '@/lib/react-hooks/generic-hooks'
import styled from '@/styles'

import { SupportSummaryContent } from './SupportSummaryContent'

interface SupportSummaryProps {
	onClickOutside?(e: { target: EventTarget | null }): void
	onClickItem?(e: React.MouseEvent<Element>): void
}

const StyledSummaryContent = styled(SupportSummaryContent)`
	overflow-y: auto;
	height: auto;
	max-height: 500px;
	width: 280px;
	position: absolute;
	top: calc(100% + 5px);
	right: 215px;
	transformorigin: top right;
	boxshadow: ${boxShadowFloat};
`

export const SupportSummary: React.FunctionComponent<SupportSummaryProps> = (props) => {
	const { onClickOutside, onClickItem } = props

	function handleClickOutside(e: { target: EventTarget | null }) {
		if (onClickOutside) {
			onClickOutside(e)
		}
	}

	const containerRef = React.useRef<HTMLDivElement | null>(null)
	useOnClickOutsideOnDesktop({ containerRef, onClickOutside: handleClickOutside })

	return <StyledSummaryContent onClickOutside={onClickOutside} onClickItem={onClickItem} ref={containerRef} />
}
